function addSymbolIterator(obj: any) {
  try {
    obj[Symbol.iterator] = function () {
      return this;
    };
  } catch (error) {
    // pass
  }
}

function addSymbolIteratorFallback(obj: any) {
  obj["@@iterator"] = function () {
    return this;
  };
}

export function wrapNextFunction(next: () => any) {
  const iter = { next };
  addSymbolIterator(iter);
  addSymbolIteratorFallback(iter);
  return iter;
}
